import { SELECTIVE_TRANSFER_PAGE, TAB_KEY, TAB_KEY_TO_RESOURCE, displayDateFormat } from 'constants/assetTransfer';
import api from 'api';
import TypeItem from 'records/TypeItem';
import { designTypeMap } from 'constants/designType';
import moment from 'moment';
import { generateAssetTransferEntity } from 'components/SelectiveTransfer/selectiveTransferHelper';

export const SELECTIVE_TRANSFER_RESET = 'SELECTIVE_TRANSFER_RESET';
export const SELECTIVE_TRANSFER_SET_PAGE = 'SELECTIVE_TRANSFER_SET_PAGE';
export const SELECTIVE_TRANSFER_GO_NEXT = 'SELECTIVE_TRANSFER_GO_NEXT';
export const SELECTIVE_TRANSFER_GO_BACK = 'SELECTIVE_TRANSFER_GO_BACK';
export const SELECTIVE_TRANSFER_CHANGE_TAB = 'SELECTIVE_TRANSFER_CHANGE_TAB';
export const SELECTIVE_TRANSFER_ASYNC_START = 'SELECTIVE_TRANSFER_ASYNC_START';
export const SELECTIVE_TRANSFER_ASYNC_FINISH = 'SELECTIVE_TRANSFER_ASYNC_FINISH';
export const SELECTIVE_TRANSFER_SET_TAB_DATA = 'SELECTIVE_TRANSFER_SET_TAB_DATA';
export const SELECTIVE_TRANSFER_SET_SELECTED_VIEW = 'SELECTIVE_TRANSFER_SET_SELECTED_VIEW';
export const SELECTIVE_TRANSFER_ASYNC_ERROR = 'SELECTIVE_TRANSFER_ASYNC_ERROR';
export const SELECTIVE_TRANSFER_SELECT_ALL = 'SELECTIVE_TRANSFER_SELECT_ALL';
export const SELECTIVE_TRANSFER_SELECT_ASSET = 'SELECTIVE_TRANSFER_SELECT_ASSET';
export const SELECTIVE_TRANSFER_SET_SELECTIONS = 'SELECTIVE_TRANSFER_SET_SELECTIONS';
export const SELECTIVE_TRANSFER_SET_INCLUDED_ASSETS = 'SELECTIVE_TRANSFER_SET_INCLUDED_ASSETS';
export const SELECTIVE_TRANSFER_INCLUDED_ASSET_SUCCESS = 'SELECTIVE_TRANSFER_INCLUDED_ASSET_SUCCESS';
export const SELECTIVE_TRANSFER_REMOVE_DEPENDENCIES = 'SELECTIVE_TRANSFER_REMOVE_DEPENDENCIES';
export const SELECTIVE_TRANSFER_CHANGE_TRANSFER_NOTE = 'SELECTIVE_TRANSFER_CHANGE_TRANSFER_NOTE';
export const SELECTIVE_TRANSFER_SET_SOURCE = 'SELECTIVE_TRANSFER_SET_SOURCE';
export const SELECTIVE_TRANSFER_SET_ASSET_AVAILABILITY = 'SELECTIVE_TRANSFER_SET_ASSET_AVAILABILITY';
export const SELECTIVE_TRANSFER_SET_IMPORT_ACCOUNTS_OVERLAY = 'SELECTIVE_TRANSFER_SET_IMPORT_ACCOUNTS_OVERLAY';
export const SELECTIVE_TRANSFER_SET_DESTINATION_ACCOUNTS = 'SELECTIVE_TRANSFER_SET_DESTINATION_ACCOUNTS';
export const UPDATE_DESTINATION_ACCOUNTS_ON_CHECK = 'UPDATE_DESTINATION_ACCOUNTS_ON_CHECK';
export const SELECTIVE_TRANSFER_SET_AT_THRESHOLD ='SELECTIVE_TRANSFER_SET_AT_THRESHOLD';
export const UPDATE_DESTINATION_ACCOUNTS_ON_ALL_CHECK = 'UPDATE_DESTINATION_ACCOUNTS_ON_ALL_CHECK';
export const SELECTIVE_TRANSFER_START_ASSET_TRANSFER = 'SELECTIVE_TRANSFER_START_ASSET_TRANSFER';

export const resetSelectiveTransfer = () => ({ type: SELECTIVE_TRANSFER_RESET });

const selectiveTransferAsyncStart = () => ({ type: SELECTIVE_TRANSFER_ASYNC_START });
const selectiveTransferAsyncFinish = () => ({ type: SELECTIVE_TRANSFER_ASYNC_FINISH });

const selectiveTransferAsyncError = (error) => ({ type: SELECTIVE_TRANSFER_ASYNC_ERROR, error });

/**
 * set current page to given page number
 * @param {Number} page page number
 * @returns action
 */
export const setPage = page => {
  if (Object.values(SELECTIVE_TRANSFER_PAGE).includes(page)) {
    return {
      type: SELECTIVE_TRANSFER_SET_PAGE,
      payload: { page },
    }
  }
};

export const goToNextPage = () => ({ type: SELECTIVE_TRANSFER_GO_NEXT });
export const goToPreviousPage = () => ({ type: SELECTIVE_TRANSFER_GO_BACK });

/**
 * change the current tab
 * @param {String} tab tab key name
 * @returns action
 */
export const changeCurrentTab = tab => {
  if (Object.values(TAB_KEY).includes(tab)) {
    return {
      type: SELECTIVE_TRANSFER_CHANGE_TAB,
      payload: { tab }
    }
  }
};

/**
 * set tab data to a specific tab
 * @param {String} tab tab key
 * @param {Array} data tab data
 */
const setTabData = (tab, data) => ({
  type: SELECTIVE_TRANSFER_SET_TAB_DATA,
  payload: {
    tab,
    data: data && data.map(item => ({
      ...item,
      isSelected: false,
      source: [],
    })),
  }
});

/**
 * fetch recipe assets data
 * @returns action creator
 */
export const fetchRecipeAssets = (brandId) => {
  return (dispatch) => {

    dispatch(selectiveTransferAsyncStart());
    return api.request(`recipe/list?brandId=${brandId}`, 'get')
      .then((data) => {
        const recipeData = data.map(recipe => {
          return {
            ...recipe,
            price: `$${recipe.price}`,
            costPerServing: `$${recipe.costPerServing}`,
            profit: `$${recipe.profit}`,
          }
        });
        return dispatch(setTabData(TAB_KEY.RECIPE, recipeData));
      }).catch((err) => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw (err);
      });
  }
};

/**
 * fetch batch recipe assets data
 * @returns action creator
 */
export const fetchBatchRecipeAssets = (brandId, unitTypes) => {
  return (dispatch) => {

    dispatch(selectiveTransferAsyncStart());
    return api.request(`recipe/list?brandId=${brandId}&fetchBatch=true`, 'get')
      .then((data) => {
        const batchRecipeData = data.map(batchRecipe => {
          const amountUnitTextKey = TypeItem.findTypeItemById(unitTypes, batchRecipe.yieldUnits).abbreviation;
          return {
            ...batchRecipe,
            costPerServing: `$${batchRecipe.costPerServing}`,
            costPerPortion: `$${batchRecipe.costPerPortion}/${amountUnitTextKey}`,
            yield: batchRecipe.yield ? `${batchRecipe.yield}/${amountUnitTextKey}` : batchRecipe.yield,
          }
        });
        return dispatch(setTabData(TAB_KEY.BATCH_RECIPE, batchRecipeData));
      }).catch((err) => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw (err);
      });
  }
};

/**
 * fetch menu assets data
 * @returns action creator
 */
export const fetchMenuAssets = (brandId) => {
  return (dispatch) => {

    dispatch(selectiveTransferAsyncStart());
    return api.request(`menu/list?menuType=E&brandId=${brandId}&sourceType=`, 'get')
      .then((data) => {
        const menuData = data.map(menu => {
          return {
            ...menu,
            cost: `${menu.cost}%`,
          }
        });
        return dispatch(setTabData(TAB_KEY.MENU, menuData));
      }).catch((err) => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw (err);
      });
  }
};


/**
 * fetch design assets data
 * @returns action creator
 */
export const fetchDesignAssets = (brandId, designTypes, sizeTypes) => {
  return (dispatch) => {

    dispatch(selectiveTransferAsyncStart());
    return api.request(`design/designlist?&brandId=${brandId}&menuType=`, 'get')
      .then((data) => {
        const designData = data.map(design => {
          const parentTypeItem = TypeItem.findTypeItemById(designTypes, design.designTypeItemId);
          const sizeTypeItem = TypeItem.findTypeItemById(sizeTypes, design.sizeTypeItemId);
          const customDesign = design.designTypeName === designTypeMap.CUSTOM_DESIGN;
          return {
            ...design,
            designTypeName: parentTypeItem.typeItemName,
            designSize: design.imported || customDesign ? null : `${sizeTypeItem.typeItemName} - ${sizeTypeItem.abbreviation}`,
            updated: moment(design.updated).format(displayDateFormat),
          };
        });
        return dispatch(setTabData(TAB_KEY.DESIGN, designData));
      }).catch((err) => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw (err);
      });
  }
};

/**
 * store asset selection changes
 * @param {String} tab tab key
 * @param {Array} data data with selection changes
 * @param {Array} selectedAssets selected id array
 */
export const storeSelections = (tab, data, selectedAssets, isAllSelected) => ({
  type: SELECTIVE_TRANSFER_SET_SELECTIONS,
  payload: { tab, data, selectedAssets, isAllSelected }
})

/**
 * fetch custom ingredient assets data
 * @returns action creator
 */
export const fetchCustomIngredietntAssets = (brandId) => {
  return (dispatch) => {

    dispatch(selectiveTransferAsyncStart());
    return api.request(`ingredient/listByType?brandId=${brandId}&ingredType=CI`, 'get')
      .then((data) => {
        const customIngredientData = data.map(ci => {
          return {
            ...ci,
            costPerUnit: `$${ci.costPerUnit} per ${ci.baseUnitTextKey}`,
          }
        });
        return dispatch(setTabData(TAB_KEY.CUSTOM_INGREDIENT, customIngredientData));
      }).catch((err) => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw (err);
      });
  }
};

/**
 * set selected view filter
 * @param {Boolean} makeVisible make selected view
 */
export const setSelectedView = makeVisible => ({
  type: SELECTIVE_TRANSFER_SET_SELECTED_VIEW,
  payload: { makeVisible },
});

/**
 * store included asset links
 * @param {String} tabKey tab key
 * @param {Array} links links
 */
const setIncludedAssets = (tabKey, links) => {
  return {
    type: SELECTIVE_TRANSFER_SET_INCLUDED_ASSETS,
    payload: {
      tabKey,
      links,
    },
  }
}

/**
 * complete included asset async fetch
 * @param {String} tabKey tab key
 */
const includedAssetSuccess = tabKey => ({
  type: SELECTIVE_TRANSFER_INCLUDED_ASSET_SUCCESS,
  payload: { tabKey }
});

/**
 * fetch included assets async
 * @param {String} tabKey tab key
 * @param {String} brandId brand id
 */
export const fetchIncludedAssets = (tabKey, brandId) => {
  const resource = TAB_KEY_TO_RESOURCE[tabKey];
  const queryParams = {
    ...((tabKey === TAB_KEY.BATCH_RECIPE) && { isBatchRecipe: true }),
    brandId,
  };

  return (dispatch, getState) => {

    const tabData = getState().selectiveTransfer.get(tabKey);

    const isAllSelected = tabData.get('isAllSelected');
    const assets = tabData.get('selectedAssets');
    const dependenciesLocked = tabData.get('dependenciesLocked');

    if (dependenciesLocked || (!assets.length && !isAllSelected)) {
      return Promise.resolve();
    }

    dispatch(selectiveTransferAsyncStart());
    return api.request(`${resource}/assets`, 'post', { allSelected: isAllSelected, assets }, null, null, queryParams)
      .then(data => {

        if (!data) {
          return;
        }
        [TAB_KEY.MENU, TAB_KEY.RECIPE, TAB_KEY.BATCH_RECIPE, TAB_KEY.CUSTOM_INGREDIENT].forEach(tab => {
          const tabLinks = data[tab];
          if (tabLinks && tabLinks.length) {
            dispatch(setIncludedAssets(tab, tabLinks));
          }
        });
        dispatch(includedAssetSuccess(tabKey));

      })
      .catch((err) => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw (err);
      });
  };
}

/**
 * remove given dependencies from child tabs
 * @param {String} tabKey tab key
 * @param {Array} dependencyIds dependency ids
 */
export const removeDependencies = (tabKey, dependencyIds) => ({
  type: SELECTIVE_TRANSFER_REMOVE_DEPENDENCIES,
  payload: { tabKey, source: dependencyIds }
});

/**
 * 
 * @param {String} value transfer note
 * @returns 
 */
export const onChangeTransferNote = value => ({
  type: SELECTIVE_TRANSFER_CHANGE_TRANSFER_NOTE,
  payload: { value: value || '' }
});

/**
 * set source account
 * @param {Object} account account object
 */
export const setSourceAccount = account => {
  if (!!account && !!account.accountId) {
    return {
      type: SELECTIVE_TRANSFER_SET_SOURCE,
      payload: { account }
    };
  }
};

/**
 * set source account asset availability
 * @param {Boolean} hasAssets has assets in the source
 */
export const setAssetAvailability = hasAssets => ({
  type: SELECTIVE_TRANSFER_SET_ASSET_AVAILABILITY,
  payload: { hasAssets }
});

/**
 * Set asset transfer request status
 */
const startAssetTransferAsync = () => ({
  type: SELECTIVE_TRANSFER_START_ASSET_TRANSFER,
})

/**
 * initiate asset transfer request
 * @param {Number} userId user id
 */
export const initiateAssetTransfer = userId => {
  return (dispatch, getState) => {

    dispatch(startAssetTransferAsync());
    const tabData = getState().selectiveTransfer;
    const body = generateAssetTransferEntity(tabData, userId);

    return api.request(`assets/transfers`, 'post', body)
      .then(() => dispatch(selectiveTransferAsyncFinish()))
      .catch(err => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw err;
      });
  }
};

/**
 * add to destinations lits
 * @param {List} accounts accounts list
 */
export const setDestinationAccounts = accounts => ({
  type: SELECTIVE_TRANSFER_SET_DESTINATION_ACCOUNTS,
  payload: { accounts }
});

/**
 * add to destinations lits
 * @param {List} accounts accounts list
 */
export const updateDestinationsOnCheck = account => ({
  type: UPDATE_DESTINATION_ACCOUNTS_ON_CHECK,
  payload: { account }
});

/**
 * open/close import accounts overlay
 * @param {Boolean} isOpen is overlay open
 */
export const setImportAccountsOverlay = isOpen => ({
  type: SELECTIVE_TRANSFER_SET_IMPORT_ACCOUNTS_OVERLAY,
  payload: { isOpen },
});

/**
 * update asset transfer threshold count
 */
export const updateAssertTransferThreshold = () => ({
  type: SELECTIVE_TRANSFER_SET_AT_THRESHOLD,
});

/**
 * upload csv file
 * @param {FormData} fileData csv file
 * @param {String} sourceAccount source account Id
 */
export const uploadAccountsCsv = (fileData, sourceAccount) => {
  return (dispatch, getState) => {

    dispatch(selectiveTransferAsyncStart());
    return api.request(`account/validate`, 'post', fileData, api.contentTypes.form)
      .then((data) => {
        return new Promise(async (resolve, reject) => {
          if (data.accounts.length === 0 && data.invalidAccounts.length === 0) {
            return reject(new Error('Invalid Format'));
          }
          const remainingDestCount = getState().selectiveTransfer.get('assetTransferThreshold') - data.accounts.length;
          if (remainingDestCount >= 0) {

            const destinations = data.accounts.map(account => ({
              ...account,
              isSelected: true
            }))

            //ommit source account if the uploaded csv contains source account id
            await dispatch(setDestinationAccounts(destinations.filter(destination => destination.accountId != sourceAccount)));
            dispatch(updateAssertTransferThreshold());
            if (data.invalidAccounts.length > 0) {
              return reject(new Error('Invalid Account Numbers: ' + data.invalidAccounts));
            }
            else {
              return resolve();
            }
          }
          else {
            return reject(new Error('Account Count Exceeded'));
          }
        })
      })
      .catch(err => {
        dispatch(selectiveTransferAsyncError(err.message));
        throw err;
      });
  }
};

/**
 * add all destination accounts to destinations list
 * @param {List} accounts accounts list
 * @param {boolean} isAllSelected isAllSelected is all selected
 */
export const updateAllAccountSelection = (accounts, isAllSelected) => ({
  type: UPDATE_DESTINATION_ACCOUNTS_ON_ALL_CHECK,
  payload: { accounts, isAllSelected }
});



